<template>
    <span>
        <button
            type="button"
            class="btn btn-brand"
            data-testid="client-candidates-export-button"
            @click="openModal"
        >
            <i class="fa fa-lg fa-download"/>
            {{ uLang("app.export_client_candidates") }}
        </button>

        <portal to="modals" v-if="showModal">
            <b-modal
                v-model="showModal"
                :title="uLang('app.export_client_candidates')"
                :ok-title="uLang('app.export')"
                :cancel-title="uLang('app.cancel')"
                @ok="downloadExport"
            >
                <div class="trajectstatus-filter" data-testid="trajectstatus-filter">
                    <div class="trajectstatus-filter__label">{{ uLang('app.trajectstatus') }}</div>

                    <div class="trajectstatus-filter__options">
                        <label
                            class="custom-control custom-radio"
                            data-testid="trajectory-status-running"
                        >
                            <input
                                type="radio"
                                class="custom-control-input"
                                :id="'trajectory-status-running-' + instanceId"
                                :name="'trajectory_status-' + instanceId"
                                value="running"
                                v-model="trajectoryStatus"
                            >
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">
                                {{ uLang('app.only_running_trajectories') }}
                            </span>
                        </label>

                        <label
                            class="custom-control custom-radio"
                            data-testid="trajectory-status-all"
                        >
                            <input
                                type="radio"
                                class="custom-control-input"
                                :id="'trajectory-status-all-' + instanceId"
                                :name="'trajectory_status-' + instanceId"
                                value="all"
                                v-model="trajectoryStatus"
                            >
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">
                                {{ uLang('app.all_trajectories') }}
                            </span>
                        </label>
                    </div>
                </div>
            </b-modal>
        </portal>
    </span>
</template>

<script>
    export default {
        name: 'ClientCandidatesExportButton',

        props: {
            routeName: {
                type: String,
                required: true,
            },
            routeParams: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                showModal: false,
                trajectoryStatus: 'running',
                instanceId: this._uid,
            };
        },

        methods: {
            openModal() {
                this.trajectoryStatus = 'running';
                this.showModal = true;
            },
            downloadExport() {
                window.location.href = route(this.routeName, {
                    ...this.routeParams,
                    trajectory_status: this.trajectoryStatus,
                });
            },
        },
    };
</script>

<style lang="css">
.trajectstatus-filter {
    margin: 0;
    padding: 0;
}

.trajectstatus-filter__label {
    display: block;
    margin: 0 0 12px;
    padding: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    color: #5a458a;
}

.trajectstatus-filter__options {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0;
    padding: 0;
}

.trajectstatus-filter__options .custom-control.custom-radio {
    display: flex;
    align-items: center;
    min-height: 24px;
    margin: 0 0 10px;
    margin-left: 0;
    padding-left: 1.75rem;
}

.trajectstatus-filter__options .custom-control.custom-radio:last-child {
    margin-bottom: 0;
}

.trajectstatus-filter__options .custom-control-indicator {
    left: 0;
}

.trajectstatus-filter__options .custom-control-description {
    font-size: 14px;
    line-height: 1.4;
    color: #333;
}
</style>
